import React from 'react';
import styles from './ApplicatorsTable.module.scss';

import _ from 'lodash';
import moment from "moment";
import { $t } from "../../helpers/translator";
import PlatformCard from "../miscellaneous/PlatformCard/PlatformCard";
import MultiSelect from "../miscellaneous/MultiSelect/MultiSelect";
import DataTableGrid from "../miscellaneous/DataTableGrid/DataTableGrid";
import api from "../../helpers/api";
import Input from "../miscellaneous/Input/Input";
import { connect } from "react-redux";
import { getUser } from "../../store/auth-slice";
import { getClinics } from "../../store/data-slice";
import DataTable from "../miscellaneous/DataTable/DataTable";
import Tooltip from "../miscellaneous/Tooltip/Tooltip";
import { BsCheckCircle } from "react-icons/bs";
import { GrUpdate } from "react-icons/gr";
import { Link } from "react-router-dom";
import Timestamp from "../miscellaneous/Timestamp/Timestamp";


class ApplicatorsTable extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            userType: props.userType || 2,    //setting type clinic as default
            applicators: [],
            updateKey: 0,

            pagination: null,
            payload: {
                sort: 'created_at',
                order: 'desc',   // or desc
                search: '',
                clinic: '',   // or id
                page: 1,
                per_page: 15,
                start_date: moment().subtract(30, 'days'),
                end_date: moment(),
                distributor_id: props.distributorId ? props.distributorId : ''
            },
            tableLoading: false,

            sortingOptions: [ {
                label: $t('global.machines.platformName'), value: 'machine_name'
            }, {
                label: $t('global.machines.platformId'), value: 'machine_id'
            }, {
                label: $t('global.applicators.dateAdded'), value: 'created_at'
            }, ],
            selectedSortingOption: {
                label: $t('global.applicators.dateAdded'), value: 'created_at'
            },

            clinicOptions: [ {
                label: $t('global.applicators.allClinics'), value: ''
            }, ],
            selectedClinicOption: [ {
                label: $t('global.applicators.allClinics'), value: ''
            }, ],

            searchString: '',

        };
    }

    async componentDidMount() {
        let state = this.state;

        if (this.props.perPage) {
            state.payload.per_page = this.props.perPage;
        }

        if (this.props.clinicId) {
            state.payload.clinic = this.props.clinicId;
        }

        if (this.props.userType && this.props.userType !== 2) {
            state.userType = this.props.userType;
        }

        console.log(this.props.userType)

        this.setState(state, async () => {
            await this.getApplicators();
            await this.getClinics();
            if (this.props.userType === 5) {
                await this.getStats();
            }
        })
    }

    getAPIUrl() {
        if (!this.state.payload) {
            return;
        }

        let payload = { ...this.state.payload };
        return `applicators?sort=${payload.sort}&order=${payload.order}&clinic=${payload.clinic}&search=${payload.search}&page=${payload.page}&per_page=${payload.per_page}&start_date=${moment(payload.start_date).format('YYYY-MM-DD')}&end_date=${moment(payload.end_date).format('YYYY-MM-DD')}&distributor_id=${payload.distributor_id}`;
    }

    async getApplicators() {
        this.setState({ tableLoading: true }, async () => {
            try {
                let payload = { ...this.state.payload };
                let res = await api.get(this.getAPIUrl());

                let pagination = null;
                let applicators = [];
                if (res && res.success) {
                    this.setState({ applicators: [], pagination: pagination }, () => {
                        // console.log(this.state.updateKey, res.data.data.data)
                        _.forEach(res.data.data.data, (v, k) => {
                            v.created_at = <Timestamp time={ v.created_at } />;
                            v.clinic = v.clinic_id ? <Link to={ `/clinic/${v.clinic_id}` }>{ v.clinic_name }</Link> : v.clinic_name;
                            v.machine_name = <Link to={ `/equipment/platform/${v.id}` }>{ `${v.machine_name}` }</Link>;
                            v.update_required = v.update_required ?
                                <Tooltip content={ $t('global.applicators.updateRequired') }><GrUpdate className={ styles.red } /></Tooltip>
                                :
                                <Tooltip content={ $t('global.applicators.upToDate') }><BsCheckCircle className={ styles.green } /></Tooltip>
                            applicators.push(v)
                        })

                        pagination = res.data.data.pagination;
                        this.setState({
                            applicators: applicators,
                            pagination: pagination,
                            updateKey: this.state.updateKey + 1
                        });
                    })
                }

            } catch (e) {
                console.error('err get applicators:', e);
            } finally {
                this.setState({ tableLoading: false });
            }
        });
    }

    async getClinics() {
        let clinics = [ ...await this.props.dispatch(getClinics()) ]

        clinics.unshift({
            label: $t('global.applicators.allClinics'), value: ''
        })
        this.setState({ clinicOptions: clinics })
    }

    async getStats() {
        try {
            let res = await api.get('applicators/kpi');
            if (res && res.success) {
                this.setState({ stats: res.data.data });
            }
        } catch (e) {
            console.error('err get stats:', e);
        }
    }


    dataTableActionHandler(data) {
        if (data.key === 'page') {
            let payload = { ...this.state.payload };
            payload.page = data.value;

            this.setState({ payload: payload }, async () => {
                await this.getApplicators();
            });
        }

        if (data.key === 'header') {
            // console.log(data.value)

            let payload = { ...this.state.payload }
            if (payload.sort === data.value) {
                payload.order = payload.order === 'desc' ? 'asc' : 'desc'
            }
            payload.sort = data.value;

            this.setState({ payload: payload }, async () => {
                await this.getApplicators();
            });
        }
    }


    fieldChangeHandler(name, data) {
        if (name === 'applicatorSN') {
            this.setState({
                applicatorNewSN: data.target.value, applicatorNewSNError: ''
            });
            return;
        }

        let payload = { ...this.state.payload };
        let selectedSortingOption = { ...this.state.selectedSortingOption };
        let selectedClinicOption = { ...this.state.selectedClinicOption };

        if (name === 'sort') {
            payload.sort = data.value;
            selectedSortingOption = data;
        }
        if (name === 'clinic') {
            payload.clinic = data.value;
            selectedClinicOption = data;
        }

        this.setState({
            payload: payload, selectedSortingOption: selectedSortingOption, selectedClinicOption: selectedClinicOption
        }, async () => {
            await this.getApplicators();
        });
    }

    nameSearchHandler(e) {
        let payload = { ...this.state.payload };
        payload.search = e.target.value;

        this.setState({ payload: payload }, async () => {
            await this.getApplicators();
        });
    }

    datesChangeHandler(dates) {
        let payload = { ...this.state.payload };
        payload.start_date = dates.startDate;
        payload.end_date = dates.endDate;

        this.setState({
            payload: payload
        }, async () => {
            // console.log(this.state);
            await this.getApplicators();
        });
    }

    nFormatter(num, digits) {
        const lookup = [
            { value: 1, symbol: "" },
            { value: 1e3, symbol: "k" },
            { value: 1e6, symbol: "M" },
            { value: 1e9, symbol: "G" },
            { value: 1e12, symbol: "T" },
            { value: 1e15, symbol: "P" },
            { value: 1e18, symbol: "E" }
        ];
        const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
        var item = lookup.slice().reverse().find(function (item) {
            return num >= item.value;
        });
        return item ? (num / item.value).toFixed(digits).replace(rx, "$1") + item.symbol : "0";
    }


    render() {
        let tableHeaders = [
            {
                name: 'Created at',
                id: 'created_at',
                clickable: true
            },
            !this.props.clinicId && {
                name: $t('global.clinics.clinicName'),
                id: 'clinic',
                accessor: 'clinic_name',
                clickable: true
            },
            {
                name: $t('global.applicators.applicatorModelName'),
                id: 'name',
                clickable: true
            },
            {
                name: $t('global.applicators.applicatorId'),
                id: 'handle_id',
                clickable: true
            },
            {
                name: $t('global.applicators.handleSN'),
                id: 'serial_number',
                clickable: true
            },
            {
                name: $t('global.machines.pulseCount'),
                id: 'pulses',
                clickable: false
            },
        ]

        return (<div className={ styles[ 'container' ] }>
            <div className={ styles[ 'box' ] }>
                <div className={ 'alma-box' }>
                    <div className={ 'alma-box-header' }>
                        <div>
                            <h3>{ $t('global.clinics.applicators') }</h3>
                        </div>
                    </div>
                    <div className={ styles.cardRow }>
                        { this.state.stats?.length > 0 && _.orderBy(this.state.stats, 'applicators_amount', 'desc').map((stat, i) => {
                            const { handle_type_id, handle_type_name, applicators_amount, pulses_amount, pulses_avg } = stat
                            return (
                                <div key={ i } className={ styles.card }>
                                    <h5>{ handle_type_name }</h5>
                                    <div className={ styles.values }>
                                        <div>
                                            <div className={ styles.value }>{ this.nFormatter(pulses_avg, 2) }</div>
                                            <span>Avg. Pulse Count</span>
                                        </div>
                                        <div>
                                            <div className={ styles.value }>{ applicators_amount }</div>
                                            <span>Total Handles</span>
                                        </div>
                                    </div>
                                </div>
                            )
                        }) }
                    </div>
                    <div className={ 'alma-fields-row' }>
                        {
                            !this.props.clinicId ?
                                <div className={ 'alma-field-container' }>
                                    <div className={ 'alma-field-header' }>{ $t('global.machines.byClinic') }</div>
                                    <MultiSelect
                                        options={ this.state.clinicOptions }
                                        selected={ this.state.selectedClinicOption }
                                        onValueChange={ (data) => this.fieldChangeHandler('clinic', data) }
                                    />
                                </div>
                                :
                                null
                        }

                        {/*<div className={'alma-field-container'}>*/ }
                        {/*    <div className={'alma-field-header'}>{$t('global.machines.sortBy')}</div>*/ }
                        {/*    <MultiSelect*/ }
                        {/*        options={this.state.sortingOptions}*/ }
                        {/*        selected={this.state.selectedSortingOption}*/ }
                        {/*        onValueChange={(data) => this.fieldChangeHandler('sort', data)}*/ }
                        {/*    />*/ }
                        {/*</div>*/ }

                        <div className={ 'alma-field-container' }>
                            <div className={ 'alma-field-header' }>{ $t('global.applicators.searchApplicator') }</div>
                            <Input name="search"
                                delay={ 500 }
                                className={ 'alma-input' }
                                type="text"
                                value={ this.state.payload.search }
                                placeholder={ $t('global.machines.nameOrId') }
                                autoComplete={ false }
                                onChange={ this.nameSearchHandler } />
                        </div>
                    </div>

                    <div>
                        <DataTable data={ this.state.applicators }
                            headers={ tableHeaders }
                            pagination={ this.state.pagination }
                            loading={ this.state.tableLoading }
                            apiUrl={ this.getAPIUrl() }
                            onAction={ (e) => this.dataTableActionHandler(e) }
                        />
                    </div>
                </div>
            </div>
        </div>
        );
    }
}


const mapStateToProps = (state) => ({
    state: state
});

export default connect(mapStateToProps)(ApplicatorsTable);
